import React from 'react';
import { Lock } from 'lucide-react';

const UnauthorizedPage = () => {
  return (
    <div className="flex flex-col items-center justify-start min-h-screen bg-gray-50 px-4 py-3 w-full">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md flex flex-col items-center justify-center" style={{maxWidth: "80vw", height: "40vh"}}>
        <div className="flex items-center justify-center mb-3" style={{border: "1px solid gray",borderRadius: "100%",width: "fit-content",padding: "14px",background: "#80808021"}}>
          <Lock className="h-12 w-12 text-gray-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
          Access Restricted
        </h1>
        
        {/* <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
          <p className="text-sm text-red-800 text-center">
          
          </p>
        </div> */}
        
        <p className="text-gray-600 mb-6 text-center" style={{maxWidth: "25rem", margin: "auto"}}>
        Your role doesn't have access to this page.
        Please contact your organization admin for access.
        </p>
      </div>
      
    </div>
  );
};

export default UnauthorizedPage;